
export function useSlideSubtitle() {
  return "";
}